import { fromIsoString, toIsoString } from '../chat/iso-date';
import type { WorkflowEventTriggerData } from './types';
import type { SerializedWorkflowEventTrigger } from './types';
import { WorkflowTrigger } from './workflow-trigger';
import type { WorkflowTriggerHydration } from './workflow-trigger';

/**
 * Standalone event trigger (`workflow_triggers_event`). Listeners match on
 * {@link WorkflowEventTrigger#eventName} when an emit-event node publishes.
 */
export class WorkflowEventTrigger extends WorkflowTrigger<WorkflowEventTriggerData> {
  readonly kind = 'event' as const;

  private constructor(
    data: WorkflowEventTriggerData,
    hydration?: WorkflowTriggerHydration
  ) {
    super(data, hydration);
  }

  get name(): string {
    return this._data.name;
  }

  get eventName(): string {
    return this._data.eventName;
  }

  get eventTriggerData(): WorkflowEventTriggerData {
    return { ...this._data };
  }

  serialize(): SerializedWorkflowEventTrigger {
    return {
      id: this._data.id,
      ownerId: this._data.ownerId,
      ownerOrgId: this._data.ownerOrgId,
      name: this._data.name,
      eventName: this._data.eventName,
      enabled: this._data.enabled,
      createdAt: toIsoString(this._data.createdAt),
      updatedAt: toIsoString(this._data.updatedAt),
    };
  }

  static fromSerialized(
    serialized: SerializedWorkflowEventTrigger,
    hydration?: WorkflowTriggerHydration
  ): WorkflowEventTrigger {
    const data: WorkflowEventTriggerData = {
      id: serialized.id,
      ownerId: serialized.ownerId,
      ownerOrgId: serialized.ownerOrgId,
      name: serialized.name,
      eventName: serialized.eventName,
      enabled: serialized.enabled,
      createdAt: fromIsoString(serialized.createdAt),
      updatedAt: fromIsoString(serialized.updatedAt),
    };
    return new WorkflowEventTrigger(data, hydration);
  }
}
